/*
* @Author: gujianghua
* @Date:   2018-06-28 12:53:58
* @Last Modified by:   gujianghua
* @Last Modified time: 2019-01-23 15:46:26
*/
import axios from 'axios'
import store from '../store'
import { getToken } from '@/utils/auth'
import { Message, MessageBox } from 'element-ui';

const protocol = document.location.protocol.replace(':', '');
// const protocol = 'https'
let BASE_API = process.env.BASE_API
let BASE_API_BASE = process.env.BASE_API_BASE
const service = axios.create({
  baseURL: BASE_API, // api的base_url
  timeout: 150000,
  headers: {
    'Content-Type': 'application/json',
    'clientType': 4,
    'productType': 6
  }
})

setInterceptor(service);


function setInterceptor(service) {
  service.interceptors.request.use(config => {
    if (store.state.user.token) {
      let token = getToken()
      config.headers[store.state.user.tokenName] = token ? token : '';
    }
    return config
  }, error => {
    console.log(error)
    Promise.reject(error)
  })

  service.interceptors.response.use(response => {
    let code = response.data.code || 200
    if (code.toString().startsWith(4367)) { // 异常状态码处理
      MessageBox.alert(response.data.msg, '提示', {
        confirmButtonText: '确定',
        showClose: false,
        type: 'error',
        callback: action => {
          store.dispatch('user/loginOut').then(() => {
            location.reload()
          })
        }
      })
      return Promise.reject(new Error(response.data.msg))
    }

    // 非异常状态码处理
    let data = response.data && response.data.data !== undefined ? response.data.data : response.data;
    if (response.data instanceof Blob) {
      data = response.data
    }
    return {
      Data: data,
      data: data,
      Success: true,
      Code: 200,
      Msg: response.data.message
    }
  }, error => {
    console.log('request.js:', error)
    // 检查http状态
    const httpStatus = error.response.status
    const rstData = error.response.data

    try {
      if (4 === Math.floor(httpStatus / 100)) {
        Message({
          message: rstData.message,
          type: 'warning'
        })
      } else {
        if (500 === httpStatus) {
          Message({
            message: rstData.detail || rstData.message,
            type: 'error'
          })
        } else {
          Message({
            message: '系统繁忙，请稍后再试',
            type: 'error'
          })
        }
      }
    } catch (e) {
      Message({
        message: error.message,
        type: 'error'
      })
      console.log('request.js catch error:', e)
    }
    return Promise.reject(error)
  })
}

export function apiOldResDeal(res) {
  let code = Math.floor(res.code.value / 10000)
  return {
    Data: res.data,
    Success: code === 200 ? true : false,
    Msg: res.message,
    Code: code
  }
}

export {
  BASE_API,
  service
}



// WEBPACK FOOTER //
// ./src/utils/request.js